import GameStatesEnum from "@/states/GameStatesEnum";
import BaseState from '@state/BaseState'
import { Signals} from "@/Imports";
import Facade from "@/Facade";

export default class LoadingState extends BaseState {

  begin() {
    Signals.continueBtnClick.add(this.onContinueBtnClick, this)
    Signals.loadAssets.dispatch()
    // console.log('check the state for the StateMachine:::', this.stateMachine, this)
  }

  onContinueBtnClick() {
    this.end()
  }

  end = () => {
    // console.log('check the state for the StateMachine:::', this.stateMachine, this)
    // this.stateMachine.setState(GameStatesEnum.OPEN_SOCKET)
    this.stateMachine.setState(Facade.initialState)
  }

  cleanUp() {
    Signals.continueBtnClick.remove(this.onContinueBtnClick, this)
  }

}
